import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { PAYROLL_URL, BASE_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, PUT } = HTTP_METHODS;
const { GET_EMPLOYEES_LOP, GET_SIX_MONTH_LOP_OVERTIME, UPDATE_LOP_CORRECTION } = PAYROLL_URL;
const { PAYROLL } = BASE_ROUTE;

export const payrollApi = createApi({
  reducerPath: 'payrollApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getEmployeesLOP: builder.query({
      query: (data) => ({
        url: `${PAYROLL}${GET_EMPLOYEES_LOP}${buildQueryString(data)}`,
        method: GET
      })
    }),
    getSixMonthLopOvertime: builder.query({
      query: (data) => ({
        url: `${PAYROLL}${GET_SIX_MONTH_LOP_OVERTIME}${buildQueryString(data)}`,
        method: GET
      })
    }),
    updateLopCorrection: builder.mutation({
      query: (data) => ({
        url: `${PAYROLL}${UPDATE_LOP_CORRECTION}/${data.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetEmployeesLOPQuery,
  useGetSixMonthLopOvertimeQuery,
  useUpdateLopCorrectionMutation
} = payrollApi;
